import { useIntercom } from 'react-use-intercom'
import { SupportComponent } from '../../../../../components/stories/organisms/top-navigation/components/utility-icons/support'

const Support = () => {
  const { show } = useIntercom()

  return <SupportComponent key="support" onClick={show} />
}

export default Support
